
const formatDate = (date) => {
    const newDate = new Date(date * 1000)

    return newDate.getDate() + "." + (newDate.getMonth() + 1) + "." + newDate.getFullYear()
}

export default formatDate